import { render, staticRenderFns } from "./AdminArchivosServiciosConexion.vue?vue&type=template&id=51de5a3e&"
import script from "./AdminArchivosServiciosConexion.vue?vue&type=script&lang=js&"
export * from "./AdminArchivosServiciosConexion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports